export class Sorteable {
    sorted: boolean = true;
    unsorted: boolean = false;
    empty: boolean = true;
}
